"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.removeToken = exports.saveToken = exports.getTokenString = exports.getToken = exports.isAuthenticated = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _jsonwebtoken = require("jsonwebtoken");

var _frontendUtils = require("@engaging-tech/frontend-utils");

var DEFAULT_COOKIE_NAME = "_ewsid";
/**
 * Removes the "JWT  " prefix from a base64 decoded JWT token string.
 * We don't know why this prefix is attached to the decoded string, but
 * we have to remove it so whatever I guess.
 * @param {string} tokenString A base64 decoded string.
 * @returns {string} The same string, but without the "JWT  " prefix.
 */

var extractToken = function extractToken(tokenString) {
  return tokenString ? tokenString.replace(/JWT\s/, "").trim() : null;
};
/**
 * Adds the "JWT  " prefix to a JWT token string.
 * @param {string} tokenString The encoded token to be prefixed.
 */


var insertPrefix = function insertPrefix(tokenString) {
  return "JWT  " + tokenString;
};
/**
 * Decodes a base64 encoded string.
 * @param {string} encodedToken A base64 encoded string
 * @returns {string} A decoded string
 */


var decodeTokenString = function decodeTokenString(encodedToken) {
  return encodedToken ? atob(encodedToken) : null;
};
/**
 * Base64 encodes a JWT token string.
 * @param {string} token The token to be encoded.
 * @returns {string} The encoded string.
 */


var encodeTokenString = function encodeTokenString(token) {
  return token ? btoa(token) : null;
};
/**
 * Checks for the presence of an authentication cookie to determine if a visitor is authenticated or
 * not.
 * @param {string} name The name of the cookie to check authentication against. Defaults to "_ewsid".
 * @param {*} storage A storage object to retrieve the string from. Defaults to the js-cookie library.
 * If a custom storage object is handed in, it *must* implement a get function.
 * @returns {boolean} true if an authentication cookie is present, false otherwise.
 */


var isAuthenticated = function isAuthenticated(name, storage) {
  if (name === void 0) {
    name = DEFAULT_COOKIE_NAME;
  }

  if (storage === void 0) {
    storage = _jsCookie["default"];
  }

  return !!storage.get(name);
};
/**
 * Retrieves a JWT token from a cookie.
 * @param {string} name The name of the cookie in which the token is stored as a value.
 * @param {*} storage A storage object to retrieve the string from. Defaults to the js-cookie library.
 * If a custom storage object is handed in, it *must* implement a get function (i.e. storage.get()).
 * @param {function} toJWT A callback function to convert the string into a JWT object.
 * @returns {object} The decoded JWT.
 */


exports.isAuthenticated = isAuthenticated;

var getToken = function getToken(name, storage, toJWT) {
  if (name === void 0) {
    name = DEFAULT_COOKIE_NAME;
  }

  if (storage === void 0) {
    storage = _jsCookie["default"];
  }

  if (toJWT === void 0) {
    toJWT = _jsonwebtoken.decode;
  }

  return (0, _frontendUtils.pipe)(storage.get, decodeTokenString, extractToken, toJWT)(name);
};
/**
 * Retrieves a token in string format from a cookie.
 * @param {string} name The name of the cookie in which the token is stored as a value.
 * @param {*} storage A storage object to retrieve the string from. Defaults to the js-cookie library.
 * If a custom storage object is handed in, it *must* implement a get function (i.e. storage.get())
 */


exports.getToken = getToken;

var getTokenString = function getTokenString(name, storage) {
  if (name === void 0) {
    name = DEFAULT_COOKIE_NAME;
  }

  if (storage === void 0) {
    storage = _jsCookie["default"];
  }

  return (0, _frontendUtils.pipe)(storage.get, decodeTokenString, extractToken)(name);
};
/**
 * Saves a token to a cookie.
 * @param {string} token The token to save to a cookie.
 * @param {string} name The name of the cookie the token should be saved in.
 * @param {*} storage A storage object to save the token to. If a custom storage object is handed in,
 * it *must* implement a set function (i.e. storage.set())
 */


exports.getTokenString = getTokenString;

var saveToken = function saveToken(token, name, storage) {
  if (name === void 0) {
    name = DEFAULT_COOKIE_NAME;
  }

  if (storage === void 0) {
    storage = _jsCookie["default"];
  }

  return (0, _frontendUtils.pipe)(insertPrefix, encodeTokenString, function (encodedToken) {
    return storage.set(name, encodedToken);
  })(token);
};
/**
 * Removes the token for the currently authenticated user by deleting the cookie.
 * @param {string} name The name of the cookie in which the token is stored as a value.
 * @param {*} storage A storage object to retrieve the string from. Defaults to the js-cookie library.
 * If a custom storage object is handed in, it *must* implement a remove function (i.e. storage.remove()).
 */


exports.saveToken = saveToken;

var removeToken = function removeToken(name, storage) {
  if (name === void 0) {
    name = DEFAULT_COOKIE_NAME;
  }

  if (storage === void 0) {
    storage = _jsCookie["default"];
  }

  return storage.remove(name);
};

exports.removeToken = removeToken;